<elcia-card [title]="'Information'">
  <div class="flex flex-col gap-4">
    <div class="flex gap-4">
      <div class="flex-1">
        <elcia-legal-entity-dropdown [control]="this.fg().controls.legalEntityId" [isMulti]="false"/>
      </div>
      <div class="flex-1">
        <elcia-date-picker [control]="this.fg().controls.creditNoteDate" [label]="'credit-note.date' | translate"/>
      </div>
    </div>
    <div class="flex gap-4">
      <div class="flex-1">
        <elcia-party-dropdown [control]="this.fg().controls.customerId" [isMulti]="false"
                              [partyTypes]="this.partyTypes()"/>
      </div>
      <div class="flex-1"></div>
    </div>
  </div>
</elcia-card>

<br>

<elcia-card [title]="'invoice.details' | translate">
  @if (canEditLines()) {
    <div class="flex flex-col gap-4">
      @for (lineForm of this.fg().controls.lines.controls; track $index) {
        <elcia-credit-note-line-form
          (onRemove)="removeLine($index)"
          [creditNoteDate]="creditNoteDateValue()"
          [fg]="lineForm"
          [legalEntityId]="legalEntityIdValue()"
        />
      }
    </div>
    <p-divider/>
    <div class="flex justify-between">
      <div>
        @if (!linkedToInvoice()) {
          <elcia-button (onClick)="addLine()" [icon]="'plus'" [label]="'action.add-invoice-line' | translate"/>
        }
      </div>
      <div class="w-2/6 py-2">
        <elcia-amount-recap [invoiceLines]="lineRecap()"/>
      </div>
    </div>
  } @else {
    <p class="text-sm text-surface-400 italic py-2">{{ 'invoice.lines-locked' | translate }}</p>
  }
</elcia-card>
